module.exports = __webpack_public_path__ + "img/grey_back.5f2156c0.png";